module.exports = __webpack_public_path__ + "static/blog-4-cfabfd0488d3d33537c86508145e26e0.jpg";